import { render, staticRenderFns } from "./UDashboard.vue?vue&type=template&id=0dd6f455&scoped=true&"
import script from "./UDashboard.vue?vue&type=script&lang=ts&"
export * from "./UDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./UDashboard.vue?vue&type=style&index=0&id=0dd6f455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6f455",
  null
  
)

export default component.exports